import "date-fns";
import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Button,
  Table,
  TableRow,
  TableCell,
  TableFooter
} from "@material-ui/core";
import Style from "../style.module.scss";
import MUIDataTable from "mui-datatables";
import MisHeader from "../MisHeader";
import Loading from "../../../../Components/Loading";

const ActivityReport = props => {
  const [pageLoading, setPageLoading] = useState(props.loading);
  const [flattenedData, setFlattenedData] = useState([]);

  // Flatten all project data into a single array with project name
  useEffect(() => {
    const flattened = [];
    props.projects.forEach(project => {
      if (project.data && Array.isArray(project.data)) {
        project.data.forEach(item => {
          flattened.push({
            ...item,
            projectName: project.projectName
          });
        });
      }
    });
    setFlattenedData(flattened);
  }, [props.projects]);

  useEffect(() => {
    setPageLoading(props.loading)
  }, [props.loading])

  function findQuantity(filteredList) {
    let totals = {
      rTotal: 0,
      tTotal: 0,
      dTotal: 0,
      eTotal: 0,
    };

    filteredList.forEach((item, index) => {
      // Convert to numbers more aggressively
      const totalHours = Number(item.totalHours) || 0;
      const trip = Number(item.trip) || 0;
      const diesel = Number(item.diesel) || 0;
      const number = Number(item.number) || 0;
      
      // Skip if all values are 0 (empty rows)
      if (totalHours === 0 && trip === 0 && diesel === 0 && number === 0) {
        return; // Skip this iteration
      }
      
      totals.rTotal += totalHours;
      totals.tTotal += trip;
      totals.dTotal += diesel;
      totals.eTotal += number;
    });

    return totals;
  }

  let columns = []
  if (props.DprReportFormat == "Equipment Wise") {
    columns = [
      {
        name: "equipment",
        label: "Equipment",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "projectName",
        label: "Project Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "unit",
        label: "unit",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "date",
        label: "Date",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "equipmentMaterial",
        label: "Material",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "start",
        label: "Start Time",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "end",
        label: "End Time",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "remark",
        label: "Remark",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "totalHours",
        label: "Total",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "trip",
        label: "Trip",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "diesel",
        label: "Diesel",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "number",
        label: "Quantity",
        options: {
          filter: true,
          sort: true,
        },
      },
    ]
  }
  else if (props.DprReportFormat == 'Material Wise') {
    columns = [
      {
        name: "equipmentMaterial",
        label: "Material",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "projectName",
        label: "Project Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "equipment",
        label: "Equipment",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "unit",
        label: "unit",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "date",
        label: "Date",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "start",
        label: "Start Time",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "end",
        label: "End Time",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "remark",
        label: "Remark",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "totalHours",
        label: "Total",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "trip",
        label: "Trip",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "diesel",
        label: "Diesel",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "number",
        label: "Quantity",
        options: {
          filter: true,
          sort: true,
        },
      },
    ]
  }
  else if (props.DprReportFormat == 'Date Wise') {
    columns = [
      {
        name: "date",
        label: "Date",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "projectName",
        label: "Project Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "equipment",
        label: "Equipment",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "unit",
        label: "unit",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "equipmentMaterial",
        label: "Material",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "start",
        label: "Start",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "end",
        label: "End",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "remark",
        label: "Remark",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "totalHours",
        label: "Total",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "trip",
        label: "Trip",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "diesel",
        label: "Diesel",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
      {
        name: "number",
        label: "Quantity",
        options: {
          customHeadRender: ({ index, ...column }) => {
            return (
              <TableCell key={index} style={{ width: '8px' }}>
                {column.label}
              </TableCell>
            );
          },
          filter: true,
          sort: true,
        },
      },
    ]
  };

  // Calculate totals for the entire flattened data
  const totals = findQuantity(flattenedData);
  

  // Custom footer render function that ensures correct column positioning
  const renderCustomFooter = () => {
    return (
      <TableFooter>
        <TableRow>
          <TableCell>Total</TableCell>
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell>{totals.rTotal.toFixed(2)}</TableCell>
          <TableCell>{totals.tTotal.toFixed(2)}</TableCell>
          <TableCell>{totals.dTotal.toFixed(2)}</TableCell>
          <TableCell>{totals.eTotal.toFixed(2)}</TableCell>
        </TableRow>
      </TableFooter>
    );
  };

  return (
    <>
      {pageLoading ? (
        <Loading loading={true} />
      ) : flattenedData.length > 0 ? (
        <div>
          <MisHeader
            startDate={props.startDate}
            endDate={props.endDate}
          />
          
          <div className={Style.table___box}>
            <MUIDataTable
              title="Equipment Report - All Projects"
              data={flattenedData}
              columns={columns}
              options={{
                selectableRows: "none",
                responsive: window.innerWidth <= 760 ? "scroll" : "simple",
                pagination: false,
                download: false,
                viewColumns: false,
                filter: true,
                print: false,
                customTableBodyFooterRender: renderCustomFooter,
              }}
            />
          </div>

        </div>
      ) : (
          <Typography
            variant="h4"
            color="textSecondary"
            style={{ marginTop: "2em", textAlign: "center" }}
          >
            Select Filter To Generate Report!!
          </Typography>
      )}
    </>
  );
};

export default ActivityReport;